/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Delete_Team_SuccessInputs */



/**
* | output |
* | --- |
* | "Team deleted successfully!" |
*
* @param {Teams_Delete_Team_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_delete_team_success = /** @type {((inputs?: Teams_Delete_Team_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Delete_Team_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Team erfolgreich gelöscht!")
	return /** @type {LocalizedString} */ ("Team deleted successfully!")
});